import {Actions} from '@redstack/shared'
import {createFileRoute} from '@tanstack/react-router'
import {OrgListPage} from '@/features/admin/OrgListPage'
import {adminOrgsQueryOptions} from '@/hooks/admin'
import {useRequirePermission} from '@/hooks/useRequirePermission'

function AdminPageGuard() {
	if (!useRequirePermission(Actions.ORGS_MANAGE)) return null
	return <OrgListPage />
}

export const Route = createFileRoute('/admin/')({
	component: AdminPageGuard,
	loader: ({context}) =>
		context.queryClient.ensureQueryData(adminOrgsQueryOptions()),
})
